var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import omit from 'lodash/omit';

import FocusTrap from '../focus-trap';

var bpfrpt_proptype_Props = {
    /** Overlay contents */
    children: PropTypes.node.isRequired,

    /** Component class names */
    className: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    shouldDefaultFocus: PropTypes.bool
};

var Overlay = function (_React$Component) {
    _inherits(Overlay, _React$Component);

    function Overlay() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Overlay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.closeOverlay = function () {
            var onClose = _this.props.onClose;

            if (!onClose) {
                return;
            }
            // @Note(wyu): I have absolutely no idea why we have to wrap it in a setTimeout here, but it works ¯\_(ツ)_/¯
            // Otherwise there will be a 'React DOM tree root should always have a node reference' error.
            setTimeout(function () {
                return onClose();
            }, 0);
        }, _this.handleOverlayKeyDown = function (event) {
            if (event.key !== 'Escape') {
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            _this.closeOverlay();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Overlay, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                rest = _objectWithoutProperties(_props, ['children', 'className']);

            var overlayProps = omit(rest, ['onClose']);
            overlayProps.className = className;
            overlayProps.handleOverlayKeyDown = this.handleOverlayKeyDown;
            overlayProps.tabIndex = 0;

            return React.createElement(
                FocusTrap,
                overlayProps,
                React.createElement(
                    'div',
                    { className: 'overlay' },
                    children
                )
            );
        }
    }]);

    return Overlay;
}(React.Component);

Overlay.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    shouldDefaultFocus: PropTypes.bool
};


export default Overlay;
import PropTypes from 'prop-types';
export { bpfrpt_proptype_Props };